import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const modulePersonalization = {
  actions,
  getters,
  mutations,
  namespaced: true,
  state: {
    currentStep: 0,
    regexRegion: "",
    views: [],
    recipeData: [],
    activeView: "personalization-main-view",
    isChangeStyleFlow: false,
    personalizationPositioning: null
  }
};

export default modulePersonalization;
